"use strict";
document.addEventListener("DOMContentLoaded", () => {
    const ROOT_MARGIN = "-20% 0px -60% 0px";
    // --- Sidebar: highlight hotel link based on visible hotel section ---
    const sidebarLinks = document.querySelectorAll(".c_subcategory ul a[href^='#']");
    const hotelSections = [];
    sidebarLinks.forEach((link) => {
        const id = link.getAttribute("href").substring(1);
        const section = document.getElementById(id);
        if (section)
            hotelSections.push({ el: section, link });
    });
    if (hotelSections.length) {
        const sidebarObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const match = hotelSections.find((h) => h.el === entry.target);
                if (!match)
                    return;
                if (entry.isIntersecting) {
                    sidebarLinks.forEach((l) => l.classList.remove("active-item"));
                    match.link.classList.add("active-item");
                }
                else {
                    match.link.classList.remove("active-item");
                }
            });
        }, { rootMargin: ROOT_MARGIN });
        hotelSections.forEach((h) => sidebarObserver.observe(h.el));
    }
    // --- Hotel nav: scroll-based highlight for short sub-sections ---
    const hotelNavData = [];
    document.querySelectorAll(".s_hotels__hotel").forEach((hotel) => {
        const nav = hotel.querySelector(".s_hotels__hotel-nav");
        if (!nav)
            return;
        const navLinks = Array.from(nav.querySelectorAll("a[href^='#']"));
        const targets = [];
        navLinks.forEach((link) => {
            const id = link.getAttribute("href").substring(1);
            const target = document.getElementById(id);
            if (target)
                targets.push({ el: target, link });
        });
        if (targets.length)
            hotelNavData.push({ hotel, navLinks, targets });
    });
    if (hotelNavData.length) {
        const onScroll = () => {
            const refLine = window.innerHeight * 0.2;
            // ─── FÁZE 1: všechna čtení najednou ───────────────────────────────
            const results = hotelNavData.map(({ hotel, navLinks, targets }) => {
                const hotelRect = hotel.getBoundingClientRect();
                const inView = hotelRect.top < window.innerHeight && hotelRect.bottom > 0;
                let activeLink = null;
                if (inView) {
                    for (let i = targets.length - 1; i >= 0; i--) {
                        if (targets[i].el.getBoundingClientRect().top <= refLine) {
                            activeLink = targets[i].link;
                            break;
                        }
                    }
                }
                return { navLinks, inView, activeLink };
            });
            // ─── FÁZE 2: všechny zápisy najednou ──────────────────────────────
            results.forEach(({ navLinks, inView, activeLink }) => {
                navLinks.forEach((l) => l.classList.remove("active"));
                if (inView && activeLink)
                    activeLink.classList.add("active");
            });
        };
        let ticking = false;
        window.addEventListener("scroll", () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    onScroll();
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
        onScroll();
    }
});
